<template>
  <filter-bar
    label="Non Lead Pipeline"
    :filter-text="filterText"
    :reset="resetFilters"
    has-refresh-button
    :refresh="refresh"
  >
    <filter-item>
      <filter-statuses
        store-module="nonLeadState"
        filter-name="nonLead"
        @change="changeStatusesFilter"
        statuses-name="nonLeadStatusesInView"
      ></filter-statuses>
    </filter-item>

    <filter-item>
      <filter-campaigns
        store-module="nonLeadState"
        filter-name="nonLead"
        @change="changeCampaignFilter"
      ></filter-campaigns>
    </filter-item>

    <filter-item>
      <filter-sources
        store-module="nonLeadState"
        filter-name="nonLead"
        @change="changeSourceFilter"
      ></filter-sources>
    </filter-item>
  </filter-bar>
</template>

<script>
export default {
  name: "NonLeadFilters",
  props: {
    refresh: {
      type: Function,
      default: () => {
      }
    }
  },
  data() {
    return {
      statusesFilterText: null,
      campaignsFilterText: null,
      sourcesFilterText: null,
    };
  },
  computed: {
    filterText() {
      let array = [];

      if (this.statusesFilterText) array.push(this.statusesFilterText);
      if (this.campaignsFilterText) array.push(this.campaignsFilterText);
      if (this.sourcesFilterText) array.push(this.sourcesFilterText);

      return array.join(" | ");
    }
  },
  methods: {
    changeStatusesFilter(event) {
      this.statusesFilterText = event;
      this.refresh()
    },
    changeCampaignFilter(event) {
      this.campaignsFilterText = event;
      this.refresh()
    },
    changeSourceFilter(event) {
      this.sourcesFilterText = event;
      this.refresh()
    },
    resetFilters() {
      this.statusesFilterText = null;
      this.campaignsFilterText = null;
      this.sourcesFilterText = null;

      this.$store.commit("nonLeadState/resetFilters", "nonLead");
    },
  }
};
</script>

<style lang="scss" scoped>
@import "../../../../../styles/variables/variables";

.filter_bar {
  padding-right: $defaultGap + 16px!important;
}
</style>
